import * as React from "react";
import FeberLogoSrc from "../../../assets/pictures/FEBERLogo.png";
import Helper from "../../../core/libraries/Helper";
import { RootState } from "../../../store/store";
import { connect } from "react-redux";
import { IUserProfile } from "../../Auth/types";
import RbSearchField from "../../../bosch-react/components/search-field/RbSearchField";
import RbLabel, {
  LabelSize,
} from "../../../bosch-react/components/label/RbLabel";
import RbDivider from "../../../bosch-react/components/divider/RbDivider";
import { withRouter } from "react-router-dom";
import Subscriptions from "../../Subscriptions/components/Subscriptions";
import NotificationModal from "../../ValidOrder/NotificationModal";
import { insertStatisticData, ISearchedStatistic, StatisticType } from "../../Statistics/services";
import DepartmentChangesAlert from "../../Admin/DepartmentChanges/DepartmentChangesAlert";

interface HomeProps {
  userProfile: IUserProfile | undefined;
  history: any;
}

class Home extends React.Component<HomeProps, any> {

  constructor(props: HomeProps) {
    super(props);
    this.searchText = this.searchText.bind(this);
    this.addToSearchedStatistics = this.addToSearchedStatistics.bind(this);
  }

  render() {
    let element = (
      <div className="ms-Grid">
        {/* Modal section */}
        <NotificationModal />
        <DepartmentChangesAlert />
        {/* Main Section */}
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 feber-home-logo">
            <img src={FeberLogoSrc} alt="FEBER Logo" />
          </div>

          <div className="ms-Grid-col ms-sm4 home-search-spacer" />
          <div className="ms-Grid-col ms-sm4 text-center home-search-col">
            <RbSearchField
              placeholder="Search..."
              onSearch={(event, newValue) => this.searchText(newValue)}
            />
            <RbLabel className="home-hint">
              Hint: Type * to search everything
            </RbLabel>
          </div>
          <div className="ms-Grid-col ms-sm4 home-search-spacer" />
        </div>

        <div className="ms-Grid-row">
          <RbDivider />
        </div>

        <div className="ms-Grid-row subscription-area">
          <div className="ms-Grid-col ms-sm12 text-left">
            <RbLabel size={LabelSize.XLarge} className="subscription-title">
              Subscriptions
            </RbLabel>
          </div>

          {/* Subscriptions */}
          <div className="ms-Grid-col ms-sm12">
            <Subscriptions />
          </div>
        </div>
      </div>
    );
    return element;
  }

  searchText(text: string) {
    let searchedText = text.trim() !== "" ? text.trim() : "*";
    this.addToSearchedStatistics(searchedText);
    this.props.history.push(
      `${process.env.REACT_APP_SEARCH_RESUTLS}?keyword=` +
      encodeURIComponent(Helper.encodeCustomized(searchedText))
    );
  }

  async addToSearchedStatistics(searchedText: string) {
    if (!!this.props.userProfile) {
      const { name, department, division } = this.props.userProfile
      let record: ISearchedStatistic = {
        createdBy: name,
        keyword: searchedText,
        department: department || "",
        division: division || "",
      }
      await insertStatisticData(StatisticType.Searched, record)
    }
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile
});

export default withRouter(connect(mapStateToProps)(Home));
